import React from 'react'
 import { Row,Col } from 'react-bootstrap'
const Footer = () => {
  return (
      <Row>
        <Col className='text-center py-3 bg-dark text-muted'>
          Copyright &copy; CheapShop (Created and Maintained By Amit)
        </Col>
      </Row>
  )
}

export default Footer
